import {types} from "mobx-state-tree";

export const DetectionModel = types.model("Detection", {
  timestamp: types.string,
  text: types.optional(types.string, ""),
  distance: types.number,
  postionFrom: types.optional(types.string, ""),
  positionTo: types.optional(types.string, ""),
  frameUrl: types.optional(types.string, ""),
  main_Code: types.optional(types.string, ""),
  c1: types.optional(types.string, ""),
  c2: types.optional(types.string, ""),
  q1: types.optional(types.string, ""),
  q2: types.optional(types.string, ""),
  sa: types.optional(types.string, ""),
})

